import { DialogProps } from "models/propTypes/dialogPropTypes";
import FileViwerContextProvider from "../fileViewer/context/contextProvider";
import WizardDialog from "./_wizardDialog";
import WizardDialogContextProvider from "../wizardDialog/context/contextProvider";

const WizardDialogWrapper: React.FC<DialogProps> = (props) => {
  return (
    <WizardDialogContextProvider>
      <FileViwerContextProvider>
        <WizardDialog {...props}></WizardDialog>
      </FileViwerContextProvider>
    </WizardDialogContextProvider>
  );
};

export default WizardDialogWrapper;
